import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/nutritionInformation/importer/nutritionInformationImporterActions';

export default importerReducers(actions);
